import ActionNames from '../../actions/names';
import Immutable from 'seamless-immutable';

const initialState = Immutable({
  loading: false,
  data: [],
  error: null
});

function brandMetadataReducer(state = initialState, action) {
  switch (action.type) {
    case ActionNames.REQUEST_BRAND_METADATA:
      return state.merge({ data: [], loading: true });
    case ActionNames.RECEIVE_BRAND_METADATA:
      return state.merge({ data: action.data, loading: false });
    case ActionNames.FAILURE_BRAND_METADATA:
      return state.merge({ error: action.error, loading: false });
    default:
      return state;
  }
}

export default brandMetadataReducer;
